import React, { useState, useEffect } from 'react';
import resumeAPI from '../../services/api';
import ResumeBrandingWrapper from './ResumeBrandingWrapper';

const JsonResumeThemeRenderer = ({ resume, templateId }) => {
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Handle various ID field formats
  const resumeId = resume?.id || resume?._id || resume?.resume_id;

  useEffect(() => {
    if (!resumeId || !templateId) {
      console.log('[JsonResumeThemeRenderer] Missing required fields:', { resumeId, templateId, resumeFields: resume ? Object.keys(resume) : [] });
      setLoading(false);
      setError(!resumeId ? 'Resume ID not found' : 'Template ID not specified');
      return;
    }

    const fetchRenderedTemplate = async () => {
      setLoading(true);
      setError(null);
      
      try {
        console.log('[JsonResumeThemeRenderer] Fetching template:', { resumeId, templateId });
        const renderedHtml = await resumeAPI.renderTemplate(resumeId, templateId);
        
        if (!renderedHtml) {
          throw new Error('Empty HTML response from server');
        }
        
        setHtml(renderedHtml);
        console.log('[JsonResumeThemeRenderer] Template loaded successfully, HTML length:', renderedHtml.length);
      } catch (err) {
        console.error('[JsonResumeThemeRenderer] Error:', err);
        console.error('[JsonResumeThemeRenderer] Error details:', {
          message: err.message,
          status: err.status,
          resumeId,
          templateId
        });
        setError(err.message || 'Failed to load template');
      } finally {
        setLoading(false);
      }
    };

    fetchRenderedTemplate();
  }, [resumeId, resume?.updatedAt, templateId]); // Re-fetch when resume changes

  if (loading) {
    return (
      <ResumeBrandingWrapper resume={resume}>
        <div className="flex items-center justify-center p-8 text-gray-500">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mr-3"></div>
          Rendering template...
        </div>
      </ResumeBrandingWrapper>
    );
  }

  if (error) {
    return (
      <ResumeBrandingWrapper resume={resume}>
        <div className="flex items-center justify-center p-8 text-red-600">
          <div className="text-center">
            <svg className="mx-auto h-12 w-12 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <p className="mt-2 font-semibold">Template rendering failed</p>
            <p className="mt-1 text-sm">{error}</p>
          </div>
        </div>
      </ResumeBrandingWrapper>
    );
  }

  if (!html) return null;

  const globalFs = resume?.font_size_global;
  return (
    <ResumeBrandingWrapper resume={resume} hidePhotoOverlay={true}>
      <div className="jsonresume-template" style={globalFs ? { fontSize: `${globalFs}pt` } : {}}>
        <style>{`
          .jsonresume-template .floating-nav,
          .jsonresume-template .floating-nav-trigger,
          .jsonresume-template .js-floating-nav,
          .jsonresume-template .js-floating-nav-trigger { display: none !important; }

          .jsonresume-template #certificates > .icon { display: none !important; }

          .jsonresume-template .profile-pic:has(img:not([src])),
          .jsonresume-template .profile-pic:has(img[src=""]),
          .jsonresume-template .profile-pic:has(img[src="undefined"]),
          .jsonresume-template .profile-pic:has(img[src="null"]) { display: none !important; }
        `}</style>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </ResumeBrandingWrapper>
  );
};

export default JsonResumeThemeRenderer;
